export const translations = {
  filters: {
    filterMethodLabel: {
      'en-150': 'Section',
      'sk-SK': 'Členenie'
    },
    filterMethodDomestic: {
      'en-150': 'Domestic',
      'sk-SK': 'Domáci'
    },
    filterMethodEconomy: {
      'en-150': 'Economy',
      'sk-SK': 'Ekonomika'
    },
    filterMethodForeign: {
      'en-150': 'Foreign',
      'sk-SK': 'Zahraničie'
    },
    filterMethodSport: {
      'en-150': 'Sport',
      'sk-SK': 'Šport'
    },
    filterMethodCulture: {
      'en-150': 'Culture',
      'sk-SK': 'Kultúra'
    },
    filterMethodHungary: {
      'en-150': 'Hungarian',
      'sk-SK': 'Maďarské'
    },
    filterOutputMethodLabel: {
      'en-150': 'Type',
      'sk-SK': 'Spôsob'
    },
    filterOutputMethodText: {
      'en-150': 'Text',
      'sk-SK': 'Text'
    },
    filterOutputMethodVideo: {
      'en-150': 'Video',
      'sk-SK': 'Video'
    },
    filterOutputMethodAudio: {
      'en-150': 'Audio',
      'sk-SK': 'Zvuk'
    },
    filterOutputMethodLive: {
      'en-150': 'Live',
      'sk-SK': 'Live'
    },
    filterOutputMethodLink: {
      'en-150': 'Archive',
      'sk-SK': 'Link'
    },
    filterOutputMethodPhoto: {
      'en-150': 'Photo',
      'sk-SK': 'Foto'
    },
    filterLocationLabel: {
      'en-150': 'Region',
      'sk-SK': 'Kraj'
    },
    filterLocationBA: {
      'en-150': 'Bratislava',
      'sk-SK': 'Bratislavský'
    },
    filterLocationTT: {
      'en-150': 'Trnava',
      'sk-SK': 'Trnavský'
    },
    filterLocationNR: {
      'en-150': 'Nitra',
      'sk-SK': 'Nitriansky'
    },
    filterLocationTN: {
      'en-150': 'Trenčín',
      'sk-SK': 'Trenčiansky'
    },
    filterLocationBB: {
      'en-150': 'Banská Bystrica',
      'sk-SK': 'Banskobystrický'
    },
    filterLocationZA: {
      'en-150': 'Žilina',
      'sk-SK': 'Žilinský'
    },
    filterLocationPO: {
      'en-150': 'Prešov',
      'sk-SK': 'Prešovský'
    },
    filterLocationKE: {
      'en-150': 'Košice',
      'sk-SK': 'Košický'
    },
    filterSportLabel: {
      'en-150': 'Sport',
      'sk-SK': 'Šport'
    },
    filterSportGeneric: {
      'en-150': 'Generic',
      'sk-SK': 'Všeobecný'
    },
    filterSportFootball: {
      'en-150': 'Football',
      'sk-SK': 'Futbal'
    },
    filterSportHockey: {
      'en-150': 'Ice hockey',
      'sk-SK': 'Hokej'
    },
    filterSportTennis: {
      'en-150': 'Tennis',
      'sk-SK': 'Tenis'
    },
    filterSportAthletics: {
      'en-150': 'Athletics',
      'sk-SK': 'Atletika'
    },
    filterSportSkiing: {
      'en-150': 'Skiing',
      'sk-SK': 'Lyžovanie'
    },
    filterSportCars: {
      'en-150': 'Cars',
      'sk-SK': 'Motorizmus'
    },
    filterSearchPlaceholder: {
      'en-150': 'Search in event titles and descriptions',
      'sk-SK': 'Vyhľadávanie v názve a popise udalostí'
    },
    filtersLabel: {
      'en-150': 'Filter settings',
      'sk-SK': 'Nastavenie filtrovania'
    },
    applyFiltersLabel: {
      'en-150': 'Apply filters',
      'sk-SK': 'Potvrdiť filtre'
    },
    dismissFiltersLabel: {
      'en-150': 'Dismiss',
      'sk-SK': 'Zrušiť'
    }
  }
}
